import { ESdChangeReason, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import { HappyPathButton } from "./happy-path-button";
import { PropertiesButton } from "./properties-button";
import { WorkflowVersionButton } from "./workflow-version-button";
import "./design-right-menu.scss";

export interface IDesignRightMenuState {}

export interface IDesignRightMenuProps {}

class DesignRightMenu extends PureSdComponent<IDesignRightMenuProps & IWithSDProps, IDesignRightMenuState> {
  constructor(props: IDesignRightMenuProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.sd.getVisibility(ViewPart.RightMenu) !== Visibility.Visible) return null;

    // The strip is a fixed 42px column. In states whose child buttons are all
    // gated off (datasources, AI, API, scheduled jobs, config, email builder),
    // it would render as an empty reserved area — so skip it entirely unless it
    // has something to show: at least one visible button, or the right-panel
    // expand arrow (only present when that panel is collapsed).
    const isRightPanelCollapsed: boolean = this.props.sd.isRightPanelCollapsed[this.props.sd.dashboardState];
    const isButtonVisible = (part: ViewPart): boolean => this.props.sd.getVisibility(part) === Visibility.Visible;
    const hasAnyButton: boolean =
      isButtonVisible(ViewPart.PropertiesButton) ||
      isButtonVisible(ViewPart.CommentsButton) ||
      isButtonVisible(ViewPart.HappyPathButton) ||
      isButtonVisible(ViewPart.WorkflowVersionButton);
    if (!isRightPanelCollapsed && !hasAnyButton) return null;

    return (
      <div
        data-testid="kuikaRightMenu"
        data-onboarding-id="right_menu_container"
        className="kuika_verticalMenu kuika_rightMenu"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative"
        }}
      >
        {/* Re-opening a collapsed panel is the edge tab's job (designer-dashboard
            renderPanelExpandTab) — a second control here only ever appeared alongside it. */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
          <PropertiesButton data-onboarding-id="right_menu_properties" />
          <HappyPathButton data-onboarding-id="right_menu_happy-path" />
          <WorkflowVersionButton data-onboarding-id="right_menu_workflow-version" />
        </div>
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const designRightMenu = withSD<IDesignRightMenuProps>(DesignRightMenu);
export { designRightMenu as DesignRightMenu };
